/* ArtSHFT Product Image Lightbox — click to open, click to zoom, drag to pan, prev/next nav */
(function () {
  'use strict';

  const ZOOM = 2.8;

  /* ---- Build DOM ---- */
  const lb = document.createElement('div');
  lb.id = 'artshft-lightbox';
  lb.className = 'artshft-lightbox';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Product image');
  lb.innerHTML = `
    <div class="artshft-lightbox__backdrop"></div>
    <button class="artshft-lightbox__close" aria-label="Close">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </button>
    <button class="artshft-lightbox__arrow artshft-lightbox__arrow--prev" aria-label="Previous image">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9 1L3 7L9 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button class="artshft-lightbox__arrow artshft-lightbox__arrow--next" aria-label="Next image">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M5 1L11 7L5 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <div class="artshft-lightbox__stage">
      <div class="artshft-lightbox__media">
        <img class="artshft-lightbox__img" src="" alt="" draggable="false">
        <div class="artshft-lightbox__watermark">&#8203;</div>
      </div>
    </div>
    <p class="artshft-lightbox__hint"></p>
  `;
  document.body.appendChild(lb);

  const backdrop  = lb.querySelector('.artshft-lightbox__backdrop');
  const closeBtn  = lb.querySelector('.artshft-lightbox__close');
  const prevBtn   = lb.querySelector('.artshft-lightbox__arrow--prev');
  const nextBtn   = lb.querySelector('.artshft-lightbox__arrow--next');
  const stage     = lb.querySelector('.artshft-lightbox__stage');
  const wrap      = lb.querySelector('.artshft-lightbox__media');
  const img       = lb.querySelector('.artshft-lightbox__img');
  const hint      = lb.querySelector('.artshft-lightbox__hint');

  /* ---- State ---- */
  let isOpen     = false;
  let isZoomed   = false;
  let tx = 0, ty = 0;
  let isDragging = false;
  let hintTimer  = null;

  /* ---- Gallery state ---- */
  let gallery      = []; // [{src, alt}, ...]
  let currentIndex = 0;

  /* ---- Transform ---- */
  function applyTransform(instant) {
    if (instant) wrap.style.transition = 'none';
    wrap.style.transform = isZoomed
      ? `translate(${tx}px, ${ty}px) scale(${ZOOM})`
      : 'none';
    if (instant) requestAnimationFrame(() => (wrap.style.transition = ''));
  }

  function clamp() {
    const maxTx = Math.max(0, (wrap.offsetWidth  * ZOOM - stage.offsetWidth)  / 2);
    const maxTy = Math.max(0, (wrap.offsetHeight * ZOOM - stage.offsetHeight) / 2);
    tx = Math.max(-maxTx, Math.min(maxTx, tx));
    ty = Math.max(-maxTy, Math.min(maxTy, ty));
  }

  /* ---- Hint ---- */
  function showHint(text, ms) {
    clearTimeout(hintTimer);
    hint.textContent = text;
    hint.style.opacity = '1';
    hintTimer = setTimeout(() => (hint.style.opacity = '0'), ms ?? 2000);
  }

  /* ---- High-res src from srcset ---- */
  function getHighRes(imgEl) {
    if (!imgEl.srcset) return imgEl.src;
    return imgEl.srcset
      .split(',')
      .map(s => { const [url, w] = s.trim().split(/\s+/); return { url, w: parseInt(w) || 0 }; })
      .sort((a, b) => b.w - a.w)[0].url || imgEl.src;
  }

  /* ---- Nav button visibility ---- */
  function updateNavButtons() {
    const show = gallery.length > 1;
    prevBtn.style.display = show ? '' : 'none';
    nextBtn.style.display = show ? '' : 'none';
  }

  /* ---- Load image at index ---- */
  function loadIndex(index) {
    if (!gallery.length) return;
    currentIndex = (index + gallery.length) % gallery.length;
    const entry = gallery[currentIndex];

    /* Cross-fade: fade out, swap src, fade in */
    img.style.opacity = '0';
    setTimeout(() => {
      img.src = entry.src;
      img.alt = entry.alt;
      img.style.opacity = '1';
    }, 180);

    /* Reset zoom on navigation */
    isZoomed = false;
    tx = 0; ty = 0;
    lb.classList.remove('is-zoomed');
    wrap.style.transform = 'none';
  }

  /* ---- Open / Close ---- */
  function open(clickedImgEl) {
    /* Build gallery from all product media images */
    const mediaItems = Array.from(document.querySelectorAll('.product__media-item'));
    gallery = mediaItems.map(item => {
      const el = item.querySelector('img');
      return el ? { src: getHighRes(el), alt: el.alt || '' } : null;
    }).filter(Boolean);

    /* Find index of clicked image */
    const clickedSrc = getHighRes(clickedImgEl);
    currentIndex = gallery.findIndex(g => g.src === clickedSrc);
    if (currentIndex < 0) currentIndex = 0;

    /* Set initial image without cross-fade */
    img.src = gallery[currentIndex].src;
    img.alt = gallery[currentIndex].alt;
    img.style.opacity = '1';

    /* Reset zoom */
    isZoomed = false;
    tx = 0; ty = 0;
    wrap.style.transform = 'none';
    lb.classList.remove('is-zoomed');

    updateNavButtons();

    lb.className = 'artshft-lightbox is-open';
    document.body.style.overflow = 'hidden';
    isOpen = true;
    showHint('Click image to zoom', 2500);
    lb.focus?.();
  }

  function close() {
    lb.className = 'artshft-lightbox';
    document.body.style.overflow = '';
    isOpen = false;
    clearTimeout(hintTimer);
    hint.style.opacity = '0';
    setTimeout(() => { if (!isOpen) img.src = ''; }, 350);
  }

  /* ---- Navigate ---- */
  function navigate(dir) {
    if (gallery.length <= 1) return;
    loadIndex(currentIndex + dir);
    showHint('Click image to zoom', 1800);
  }

  /* ---- Zoom on click ---- */
  stage.addEventListener('click', e => {
    if (isDragging) return;

    if (isZoomed) {
      isZoomed = false;
      tx = 0; ty = 0;
      lb.classList.remove('is-zoomed');
      applyTransform();
      showHint('Click image to zoom');
    } else {
      const rect = img.getBoundingClientRect();
      const cx = e.clientX - (rect.left + rect.width  / 2);
      const cy = e.clientY - (rect.top  + rect.height / 2);
      tx = -cx * (ZOOM - 1);
      ty = -cy * (ZOOM - 1);
      isZoomed = true;
      lb.classList.add('is-zoomed');
      clamp();
      applyTransform();
      showHint('Drag to pan  ·  Click to zoom out', 1800);
    }
  });

  /* ---- Mouse drag ---- */
  stage.addEventListener('mousedown', e => {
    if (!isZoomed || e.button !== 0) return;
    isDragging = false;
    const startX = e.clientX - tx;
    const startY = e.clientY - ty;
    lb.classList.add('is-dragging');

    const onMove = e => {
      tx = e.clientX - startX;
      ty = e.clientY - startY;
      isDragging = true;
      clamp();
      applyTransform(true);
    };

    const onUp = () => {
      lb.classList.remove('is-dragging');
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      requestAnimationFrame(() => requestAnimationFrame(() => (isDragging = false)));
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  });

  /* ---- Touch: drag + pinch ---- */
  let lastT = null, touchMoved = false;
  let pinchDist0 = 0, pinchScale0 = 1;

  stage.addEventListener('touchstart', e => {
    touchMoved = false;
    if (e.touches.length === 2) {
      const [a, b] = e.touches;
      pinchDist0  = Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
      pinchScale0 = isZoomed ? ZOOM : 1;
    } else {
      lastT = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }
  }, { passive: true });

  stage.addEventListener('touchmove', e => {
    touchMoved = true;
    if (e.touches.length === 2) {
      e.preventDefault();
      const [a, b] = e.touches;
      const dist = Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);
      const newScale = pinchScale0 * (dist / pinchDist0);
      if (newScale >= 1.4 && !isZoomed) {
        isZoomed = true;
        lb.classList.add('is-zoomed');
      } else if (newScale < 1.2 && isZoomed) {
        isZoomed = false;
        tx = 0; ty = 0;
        lb.classList.remove('is-zoomed');
      }
      applyTransform();
    } else if (e.touches.length === 1 && isZoomed && lastT) {
      e.preventDefault();
      tx += e.touches[0].clientX - lastT.x;
      ty += e.touches[0].clientY - lastT.y;
      lastT = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      clamp();
      applyTransform(true);
    }
  }, { passive: false });

  stage.addEventListener('touchend', e => {
    if (!touchMoved && e.changedTouches.length === 1) {
      if (isZoomed) {
        isZoomed = false; tx = 0; ty = 0;
        lb.classList.remove('is-zoomed');
        applyTransform();
        showHint('Click image to zoom');
      } else {
        close();
      }
    }
    lastT = null;
  });

  /* ---- Controls ---- */
  backdrop.addEventListener('click', close);
  closeBtn.addEventListener('click', e => { e.stopPropagation(); close(); });
  prevBtn.addEventListener('click', e => { e.stopPropagation(); navigate(-1); });
  nextBtn.addEventListener('click', e => { e.stopPropagation(); navigate(1); });

  document.addEventListener('keydown', e => {
    if (!isOpen) return;
    if (e.key === 'Escape')     close();
    if (e.key === 'ArrowLeft')  navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  });

  /* ---- Wire product images ---- */
  /* Use capture phase so we intercept before Dawn's own handlers */
  document.addEventListener('click', e => {
    const mediaItem = e.target.closest('.product__media-item');
    if (!mediaItem) return;
    const imgEl = mediaItem.querySelector('img');
    if (!imgEl) return;
    e.preventDefault();
    e.stopPropagation();
    open(imgEl);
  }, true);
})();

/* ---- Variant pill leaf icon (DOM-injection, bypasses CSS specificity) ---- */
(function () {
  var leafUrl = '';
  document.querySelectorAll('style').forEach(function (s) {
    if (!leafUrl && s.textContent.includes('leaf-icon')) {
      var m = s.textContent.match(/url\(['"]([^'"]+leaf-icon[^'"]+)['"]\)/);
      if (m) leafUrl = m[1];
    }
  });
  if (!leafUrl) return;

  function syncLeaf() {
    document.querySelectorAll('.product-form__input--pill input[type="radio"]').forEach(function (r) {
      var label = r.nextElementSibling;
      if (!label) return;
      var icon = label.querySelector('.artshft-leaf');
      if (r.checked) {
        if (!icon) {
          icon = document.createElement('img');
          icon.className = 'artshft-leaf';
          icon.src = leafUrl;
          icon.alt = '';
          icon.setAttribute('aria-hidden', 'true');
          label.insertBefore(icon, label.firstChild);
        }
      } else {
        if (icon) icon.remove();
      }
    });
  }

  syncLeaf();
  setInterval(syncLeaf, 200);
})();
